import React, { useState } from 'react';
import { FaTerminal, FaCogs, FaClipboardList, FaInfoCircle } from 'react-icons/fa'; // import icons
import Terminal from './components/Terminal';
import Instructions from './components/Instructions';
import TopNav from './components/TopNav';
import ActivityCard from './components/Activity';
import Snipping from './components/Snipping';

const App: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<'terminal' | 'activity' | 'snipping' | 'instructions'>('terminal');

  return (
    <div className="min-h-screen bg-black text-gray-200 font-mono pt-8">
      <TopNav />

      {/* Desktop Layout */}
      <div className="max-w-screen-xl mx-auto px-4 py-10 hidden lg:block">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 mb-6 lg:mb-0 w-full">
            <Terminal />
          </div>
          <div className="lg:col-span-4 mb-6 lg:mb-0 w-full">
            <Snipping />
            <div className="mt-4">
              <ActivityCard />
            </div>
          </div>
          <div className="lg:col-span-12 mb-6 lg:mb-0 w-full">
            <Instructions />
          </div>
        </div>
      </div>

      {/* Mobile Layout with Bottom Tab Navigation */}
      <div className="lg:hidden">
        {/* Tab Navigation */}
        <div className="fixed bottom-0 left-10 right-10 p-0 flex justify-around items-center z-50 border border-cyan-600 bg-gradient-to-br from-[#1a1a1a] via-[#121212] to-[#0a0a0a] shadow-lg rounded-t-xl">
          <button
            onClick={() => setSelectedTab('terminal')}
            className={`relative flex flex-col items-center p-4 transition-all transform hover:scale-110 hover:shadow-lg ${selectedTab === 'terminal' ? 'text-cyan-400' : 'text-gray-400'} hover:text-cyan-400 rounded-xl`}
          >
            <FaTerminal className="text-2xl transition-colors duration-300 ease-in-out transform hover:text-cyan-500" />
            <span className={`absolute inset-0 bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out`}></span>
          </button>

          <button
            onClick={() => setSelectedTab('snipping')}
            className={`relative flex flex-col items-center p-4 transition-all transform hover:scale-110 hover:shadow-lg ${selectedTab === 'snipping' ? 'text-purple-400' : 'text-gray-400'} hover:text-purple-400 rounded-xl`}
          >
            <FaCogs className="text-2xl transition-colors duration-300 ease-in-out transform hover:text-purple-500" />
            <span className={`absolute inset-0 bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out`}></span>
          </button>

          <button
            onClick={() => setSelectedTab('activity')}
            className={`relative flex flex-col items-center p-4 transition-all transform hover:scale-110 hover:shadow-lg ${selectedTab === 'activity' ? 'text-yellow-400' : 'text-gray-400'} hover:text-yellow-400 rounded-xl`}
          >
            <FaClipboardList className="text-2xl transition-colors duration-300 ease-in-out transform hover:text-yellow-500" />
            <span className={`absolute inset-0 bg-gradient-to-r from-yellow-400 via-orange-500 to-red-600 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out`}></span>
          </button>

          <button
            onClick={() => setSelectedTab('instructions')}
            className={`relative flex flex-col items-center p-4 transition-all transform hover:scale-110 hover:shadow-lg ${selectedTab === 'instructions' ? 'text-pink-400' : 'text-gray-400'} hover:text-pink-400 rounded-xl`}
          >
            <FaInfoCircle className="text-2xl transition-colors duration-300 ease-in-out transform hover:text-pink-500" />
            <span className={`absolute inset-0 bg-gradient-to-r from-pink-400 via-red-500 to-yellow-600 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out`}></span>
          </button>
        </div>

        {/* Tab Content */}
        <div className="px-4 py-10">
          {selectedTab === 'terminal' && <Terminal />}
          {selectedTab === 'snipping' && <Snipping />}
          {selectedTab === 'activity' && <ActivityCard />}
          {selectedTab === 'instructions' && <Instructions />}
        </div>
      </div>
    </div>
  );
};

export default App;
